import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { JUI_NUMBER_INPUT_IMPORTS } from '@jump-tech-frontend/core-components-angular';
import { BaseQuestionComponent } from '../../question.component';
import { QuestionBase } from '@jump-tech-frontend/domain';
import { I18nKeys } from '@jump-tech-frontend/app-config';
import { buildMessages } from '../question.utils';

@Component({
  selector: 'crds-question-number',
  templateUrl: 'number-question.component.html',
  imports: [ReactiveFormsModule, ...JUI_NUMBER_INPUT_IMPORTS]
})
export class NumberQuestionComponent extends BaseQuestionComponent implements OnChanges {
  @Input() override form: UntypedFormGroup;
  @Input() override question: QuestionBase<string>;
  @Input() i18ns: I18nKeys;
  @Input() deviceContext?: string = 'desktop';

  controlSize = 'sm';

  ngOnChanges(changes: SimpleChanges) {
    if (!this.question || !Object.prototype.hasOwnProperty.call(changes, 'question')) {
      return;
    }

    this.controlSize = this.getControlSize();
  }

  getControlSize() {
    return this.deviceContext === 'mobile' ? 'lg' : 'sm';
  }

  override get show() {
    const showIfQuestionPopulated = this.question.showIf ? this.showIf : true;
    return (
      (this.question.showIfPopulated !== true || this.value) && showIfQuestionPopulated && this.question.show !== false
    );
  }

  protected readonly buildMessages = buildMessages;
}
